module.exports = "/images/bq-bo.svg?2b96beb1d3d427192abd2959be313aba";